export default __webpack_public_path__ + "static/media/sygnet.bd2efe41.svg";